import { styled } from "@mui/material";
import { green } from "@mui/material/colors";

export const StyledSnackbar = {
  Success: styled("div")({
    backgroundColor: green[600],
    flex: 1,
  }),
  Error: styled("div")(({ theme }) => ({
    backgroundColor: theme.palette.error.dark,
    flex: 1,
  })),
  Icon: styled("div")({
    fontSize: 20,
  }),
  IconVariant: styled("div")(({ theme }) => ({
    opacity: 0.9,
    marginRight: theme.spacing(1),
  })),
  Message: styled("div")({
    display: "flex",
    alignItems: "center",
  }),
  MessageFlex: styled("div")({
    flex: 1,
  }),

  variantStyles: {
    success: (theme) => ({ backgroundColor: green[600] }),
    error: (theme) => ({ backgroundColor: theme.palette.error.dark }),
    warning: (theme) => ({ backgroundColor: theme.palette.warning.dark }),
    info: (theme) => ({ backgroundColor: theme.palette.info.dark }),
  },

  StyledMessage: styled("div")({
    display: "flex",
    alignItems: "center",
  }),

  StyledIcon: styled("div")({
    fontSize: 20,
    opacity: 0.9,
    marginRight: 8,
  }),
};
